import classes from "./BeaconLoader.module.css";

export default function BeaconLoader({ size = 24, color = "#38d996" }) {
  return (
    <span
      className={classes["beacon-loader"]}
      style={{ width: size, height: size }}
    >
      <span className={classes["beacon-ring"]} style={{ borderColor: color }} />
      <span
        className={classes["beacon-ring2"]}
        style={{ borderColor: color }}
      />
      <span
        className={classes["beacon-center"]}
        style={{ background: color }}
      />
    </span>
  );
}
